// extracted by mini-css-extract-plugin
export default {"bgImage":"LandingPage_bgImage__Nh-fk","button":"LandingPage_button__CxJ6W","title":"LandingPage_title__bL27i"};